import m from "../../geodata/es2015/colombiaMuniHigh";
window.am4geodata_colombiaMuniHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/colombiaMuniHigh.js
// module id = null
// module chunks = 